import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import React from "react";
import { RouteComponentProps, Switch } from "react-router-dom";

import {
  wsmComplianceListPath,
  wsmCompliancePath,
  wsmFeeAddPath,
  wsmFeeListPath,
  wsmFeePath,
  wsmOptionSetAddPath,
  wsmOptionSetListPath,
  wsmOptionSetPath,
} from "./urls";
import WsmComplianceDetailsView from "./views/WsmComplianceDetails";
import WsmComplianceListView from "./views/WsmComplianceList";
import WsmFeeCreateView from "./views/WsmFeeCreate";
import WsmFeeDetailsView from "./views/WsmFeeDetails";
import WsmFeeListView from "./views/WsmFeeList";
import WsmOptionSetCreateView from "./views/WsmOptionSetCreate";
import WsmOptionSetDetailsView from "./views/WsmOptionSetDetails";
import WsmOptionSetListView from "./views/WsmOptionSetList";

const OptionSetDetails = ({ match }: RouteComponentProps<{ id: string }>) => (
  <WsmOptionSetDetailsView id={decodeURIComponent(match.params.id)} />
);
const FeeDetails = ({ match }: RouteComponentProps<{ id: string }>) => (
  <WsmFeeDetailsView id={decodeURIComponent(match.params.id)} />
);
// The compliance path carries a PRODUCT id: the row is a OneToOne on it.
const ComplianceDetails = ({ match }: RouteComponentProps<{ id: string }>) => (
  <WsmComplianceDetailsView productId={decodeURIComponent(match.params.id)} />
);

// Each "add" route comes before its :id route, which would otherwise match it.
const Component = () => (
  <>
    <WindowTitle title="Compose" />
    <Switch>
      <Route exact path={wsmOptionSetAddPath} component={WsmOptionSetCreateView} />
      <Route exact path={wsmOptionSetListPath} component={WsmOptionSetListView} />
      <Route exact path={wsmOptionSetPath(":id")} component={OptionSetDetails} />
      <Route exact path={wsmFeeAddPath} component={WsmFeeCreateView} />
      <Route exact path={wsmFeeListPath} component={WsmFeeListView} />
      <Route exact path={wsmFeePath(":id")} component={FeeDetails} />
      <Route exact path={wsmComplianceListPath} component={WsmComplianceListView} />
      <Route exact path={wsmCompliancePath(":id")} component={ComplianceDetails} />
    </Switch>
  </>
);

export default Component;
